export enum OrdersTableColumnIdentifiers {
  Selected = "",
  ProjectId = "projectId",
  DueDate = "dueDate",
  OrderType = "orderType",
  Status = "status",
  AccountType = "accountType",
  GainingSpid = "gainingSpid",
  LoosingSpid = "loosingSpid",
  CarrierName = "carrierName",
  NextWorkDate = "nextWorkDate",
  WorkedBy = "workedBy",
  NumberCount = "numberCount",
  Actions = "actions",
  AdminProjectId = "adminProjectId",
  ActivationDate = "activationDate",
  Operations = "operations"
}
